import type { TipoIdentificador } from '../api';

export const TIPOS_PAREAVEIS = ['TOTEM_CHECKOUT', 'TOTEM'] as const satisfies readonly TipoIdentificador[];

export type TipoPareavel = (typeof TIPOS_PAREAVEIS)[number];

export function ehTipoPareavel(tipo: TipoIdentificador): boolean {
  return (TIPOS_PAREAVEIS as readonly TipoIdentificador[]).includes(tipo);
}
